<div class="card widget niederschlag-widget">
  <h4 class="widget-title">Niederschlag</h4>
  <div class="chart-wrapper">
    <highcharts-chart [options]="chartOptions" class="niederschlag-chart"></highcharts-chart>
    @if (hasNoData) {
      <div class="no-data-overlay">Für diesen Zeitraum liegen keine Daten vor</div>
    }
  </div>
</div>
